import React from 'react';
import PropTypes from 'prop-types';

const TooltipIcon = props => {
  if (props.display === 'icon') {
    return (
      <span className="icon-reverse icon-circle">
        <i className="icon-info" />
      </span>
    );
  }
  return null;

};

TooltipIcon.propTypes = {
  display: PropTypes.oneOf(['underline', 'icon'])
};

export default TooltipIcon;
